import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

const values = [
  {
    icon: "ri-shield-check-line",
    title: "Güvenilirlik",
    desc: "Her projede en yüksek güvenlik standartlarını uygulayarak müşterilerimize kesintisiz enerji güvencesi sunuyoruz.",
  },
  {
    icon: "ri-leaf-line",
    title: "Sürdürülebilirlik",
    desc: "Çevre dostu teknolojilerle karbon ayak izini minimize eden çözümler geliştiriyoruz.",
  },
  {
    icon: "ri-settings-3-line",
    title: "Mühendislik Mükemmeliyeti",
    desc: "Deneyimli mühendislik kadromuzla her projeye özel, optimize edilmiş sistemler tasarlıyoruz.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Müşteri Odaklılık",
    desc: "Proje başlangıcından devreye almaya kadar her aşamada yanınızdayız.",
  },
];

const team = [
  {
    name: "Ahmet Yılmaz",
    role: "Genel Müdür",
    img: "https://public.readdy.ai/ai/img_res/2a55ead204b57d1b77c477b6da258dff.jpg",
  },
  {
    name: "Elif Kaya",
    role: "Baş Mühendis",
    img: "https://readdy.ai/api/search-image?query=professional%20female%20engineer%20portrait%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20intelligent%20expression%2C%20modern%20corporate%20headshot%20photography%2C%20sharp%20focus%2C%20neutral%20tones&width=400&height=400&seq=team2&orientation=squarish",
  },
  {
    name: "Murat Demir",
    role: "Ar-Ge Direktörü",
    img: "https://readdy.ai/api/search-image?query=professional%20male%20research%20director%20portrait%2C%20clean%20white%20background%2C%20smart%20casual%20attire%2C%20thoughtful%20expression%2C%20modern%20corporate%20headshot%20photography%2C%20sharp%20focus%2C%20neutral%20tones&width=400&height=400&seq=team3&orientation=squarish",
  },
  {
    name: "Selin Arslan",
    role: "Proje Yöneticisi",
    img: "https://readdy.ai/api/search-image?query=professional%20female%20project%20manager%20portrait%2C%20clean%20white%20background%2C%20business%20attire%2C%20friendly%20expression%2C%20modern%20corporate%20headshot%20photography%2C%20sharp%20focus%2C%20neutral%20tones&width=400&height=400&seq=team4&orientation=squarish",
  },
];



export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white text-[#2B2B2B] font-sans">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-0 pb-0 overflow-hidden">
        <div className="w-full h-[420px] md:h-[560px] relative">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20industrial%20energy%20storage%20facility%20exterior%2C%20large%20prefabricated%20steel%20containers%2C%20clean%20industrial%20architecture%2C%20dramatic%20sky%20with%20warm%20golden%20hour%20light%2C%20wide%20angle%20photography%2C%20professional%20industrial%20photography%2C%20minimal%20background%2C%20strong%20geometric%20lines&width=1440&height=560&seq=about-hero&orientation=landscape"
            alt="AKSESS Tesis"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-16 max-w-[1200px] mx-auto left-0 right-0">
            <p className="text-[#D4956A] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Biz Kimiz</p>
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4">
              Hakkımızda
            </h1>
            <p className="text-white/70 text-base md:text-lg max-w-lg">
              2015'ten bu yana Türkiye'nin öncü prefabrike enerji depolama çözümleri üreticisi.
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 px-6">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Misyonumuz</p>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight">
              Enerjinin Geleceğini<br />Bugünden İnşa Ediyoruz
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              AKSESS Energy Systems olarak, yenilenebilir enerji kaynaklarının güvenilir ve verimli şekilde depolanmasını sağlayan prefabrike çözümler geliştiriyoruz. Mühendislik uzmanlığımızı saha deneyimiyle birleştirerek her projeye özel, ölçeklenebilir sistemler sunuyoruz.
            </p>
            <p className="text-gray-500 text-base leading-relaxed">
              Güneş enerjisi santrallerinden endüstriyel tesislere, şebeke ölçekli depolama projelerinden off-grid uygulamalara kadar geniş bir yelpazede hizmet veriyoruz.
            </p>
          </div>

        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-6 bg-[#F9F7F5]">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-14">
            <p className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Değerlerimiz</p>
            <h2 className="text-3xl md:text-4xl font-bold">Bizi Biz Yapan İlkeler</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-lg p-6 flex flex-col gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#F5EDE6] rounded-lg">
                  <i className={`${v.icon} text-[#A66A3F] text-xl`} />
                </div>
                <h3 className="text-base font-bold">{v.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Team */}
      <section className="py-20 px-6 bg-[#F9F7F5]">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-14">
            <p className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase mb-3">Ekibimiz</p>
            <h2 className="text-3xl md:text-4xl font-bold">Liderlik Kadrosu</h2>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {team.map((member) => (
              <div key={member.name} className="bg-white rounded-lg overflow-hidden group">
                <div className="w-full h-56 overflow-hidden">
                  <img
                    src={member.img}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold">{member.name}</h3>
                  <p className="text-xs text-[#A66A3F] mt-1">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      <Footer />
    </div>
  );
}
